<template>
    <div class="cert">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow">
                    <i class="fad fa-file-certificate has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="has-text-weight-bold">
                        {{ cert.title }}
                    </div>
                    <div class="meta">
                        {{ cert.certification.title }}
                    </div>
                </div>
                <div class="column has-text-right is-narrow">
                    <div class="ml-6">
                        <b-button type="is-primary" size="is-small" @click="details=!details" outlined class="mr-3"><i class="fas fa-magnifying-glass mr-2"></i>Details</b-button>
                    </div>
                </div>
            </div>
            <div v-if="details">
                <hr class="mt-0"/>

                <div class="columns">
                    <div class="column is-narrow pr-2 mr-3">

                    </div>
                    <div class="column">
                        <div class="mb-5">
                            <div class="header"><i class="far fa-browse fa-fw"></i>Recommended Course<span v-if="cert.rec_courses.length !== 1">s</span></div>
                            <div class="pl-5 ml-1 is-size-6">
                                <div class="mt-4" v-for="c in cert.rec_courses">
                                    <div class="columns">
                                        <div class="column pt-4">
                                            <i class="fad fa-browsers mr-2 has-text-primary"></i>{{ c.title }}
                                        </div>
                                        <div class="column has-text-right">
                                            <b-button type="is-primary" size="is-small" class="mr-3" @click="$emit('course', c.id)"><i class="fas fa-magnifying-glass mr-2"></i>View Course</b-button>
                                        </div>
                                    </div>
                                    <hr class="mt-0 mb-1"/>
                                </div>
                            </div>
                        </div>
                        <div class="mb-5">
                            <div class="columns">
                                <div class="column pt-4">
                                    <div class="header"><i class="far fa-browse fa-fw"></i>Related Courses</div>
                                </div>
                                <div class="column has-text-right is-narrow">
                                    <b-button type="is-primary" size="is-small" @click="related=!related" outlined class="mr-3"><i class="fas fa-link mr-2"></i>View Related</b-button>
                                </div>
                            </div>

                            <div class="pl-5 ml-1 is-size-6">
                                <div v-if="related">
                                    <p class="meta mb-5">
                                        <i class="far fa-info-circle mr-2"></i>Content required to complete a certification can span multiple courses or have content that is common with other courses. Below are the list of courses that contain content that may also satisfy this certification. Content required for this certification is highlighted blue.
                                    </p>
                                    <div class="mt-2" v-for="c in cert.courses">
                                        <div class="columns">
                                            <div class="column pt-4">
                                                <i class="fad fa-browsers mr-2 has-text-primary"></i>{{ c.title }}
                                            </div>
                                            <div class="column has-text-right">
                                                <b-button type="is-primary" outlined size="is-small" class="mr-3" @click="$emit('course', c.id)"><i class="fas fa-magnifying-glass mr-2"></i>View Course</b-button>
                                            </div>
                                        </div>

                                        <ul>
                                            <li v-for="o in c.outline" :class="[o.type, {'cert': o.cert}]">
                                                {{ o.title }}
                                            </li>
                                        </ul>
                                        <hr class="mt-4 mb-6"/>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <div class="details">

        </div>

    </div>
</template>

<script>
    import {client as http} from "../http_client";

    export default {
        name: "CatalogCert",
        props: ['cert', 'details'],
        data: function() {
            return {
                related: false
            };
        }

    };
</script>

<style lang="scss" scoped>
    .cert {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1rem;
        }

        .meta {
            font-weight: normal;
            font-size: 0.8rem;
            color: #737881;
        }

        .header {
            font-weight: bold;
            font-size: 0.9rem;
            color: #336699;
            text-transform: uppercase;
            margin-bottom: 0.5rem;

            i {
                color: #5e5e5e;
                margin-right: 0.55rem;
            }
        }

        ul {
            border: 1px solid #eaeaea;
            border-radius: 5px;
            width: 80%;
            font-size: 0.95rem;
            margin-top: 1rem;

            li {
                border-bottom: 1px solid #eaeaea;
                padding: 0.2rem 0.8rem;
                border-radius: 0;
                box-shadow: none;

                &.HEADER {
                    background-color: #eaeaea;
                    font-weight: bold;
                }

                &.cert {
                    background-color: #7697b7;
                    color: white;
                }

                &:last-child {
                    border: none;
                }
            }

        }
    }
</style>
